export enum LoggerTypesEnum {

  CONSOLE = 'console'

}
